module.exports = __webpack_public_path__ + "static/btn 2_00004.ba058d79.png";